export const unlock = () => {
    document.querySelector(".slc-links").style.display = "none";
    document.querySelector(".slc-overlay").style.display = "none";
    document.querySelector(".locked").style.top = "0";
    document.querySelector(".locked").classList.add('unlocked');
    document.querySelector(".slc").style.maxHeight="none";
    document.querySelector(".slc").style.marginTop="0";
    document.querySelector(".slc").style.backdropFilter="none";
    document.querySelector(".slc").style.alignItems="flex-start";
}